module.exports = __webpack_public_path__ + "img/tagTrue2.881878f6.png";